import { WebchatConfiguration, WebchatConfigurationKeys } from './types';

const atestConfig: WebchatConfiguration = {
  [WebchatConfigurationKeys.APP_INSIGHTS_CONNECTION_STRING]:
    'InstrumentationKey=d6c7e6f9-ad30-4f58-a3ef-5f4d76aa1d84;IngestionEndpoint=https://northeurope-0.in.applicationinsights.azure.com/',
  [WebchatConfigurationKeys.GOOGLE_TAG_MANAGER_KEY]: 'GTM-T366PF4',
};

export default atestConfig;
